import { InfoIconButton } from "../../../elements/InfoIconButton/InfoIconButton";
import {
  StyledDropdownRoot,
  StyledHeaderSection,
  StyledHeaderTitleSection,
  StyledModalHeader,
  StyledHDivider,
  DotsContainer,
  Icons,
} from "./style";
import type React from "react";
import { useRef, useState } from "react";
import { useRootStore } from "../../../stores/hooks";
import { observer } from "mobx-react-lite";
import { AutomationThreeDotsMenu } from "../../../components/AutomationThreeDotsMenu";
import { AutomationDescriptionButton } from "./AutomationDescriptionEdit";
import { SwitcherAutomation } from "@smartsuite/react-ui/lib";
import { CloseButton } from "./CloseButton";
import { intercomOpenAutomationsArticle } from "../../../services/intercom.service";
import { SolutionColorVariables } from "@smartsuite/types";
import type { AutomationCandidate } from "../../../types/candidate";

export const Header = observer<{
  modalTitle: React.ReactNode;
  actions: React.ReactNode;
  isInputActive: boolean;
  onRename: () => void;
  onDelete: () => void;
  onDuplicate: () => void;
  onCopyLink: () => void;
  toggleStatus: (checked: boolean, automation: AutomationCandidate) => void;
  onClose: () => void;
}>(
  ({
    modalTitle,
    actions,
    isInputActive = false,
    onRename,
    onDelete,
    onDuplicate,
    onCopyLink,
    toggleStatus,
    onClose,
  }) => {
    const [isDescriptionEditMode, setIsDescriptionEditMode] =
      useState<boolean>(false);
    const store = useRootStore();
    const candidate = store.automations.candidate;

    const dropdownRootRef = useRef<HTMLDivElement>(null);

    return (
      <StyledModalHeader>
        {isInputActive ? (
          <StyledHeaderTitleSection>
            {modalTitle}
            <Icons>
              <InfoIconButton
                iconName="question-circle"
                onClick={intercomOpenAutomationsArticle}
              />
              <CloseButton onClick={onClose} />
            </Icons>
          </StyledHeaderTitleSection>
        ) : (
          <>
            <StyledHeaderTitleSection>
              <StyledDropdownRoot ref={dropdownRootRef} />
              {modalTitle}
              <AutomationDescriptionButton
                isEditActive={isDescriptionEditMode}
                setIsEditActive={setIsDescriptionEditMode}
              />
              {(candidate.self.description.length > 0 ||
                isDescriptionEditMode) && <StyledHDivider marginL={6} />}
              {!candidate.showErrorSection && (
                <>
                  <DotsContainer>
                    <AutomationThreeDotsMenu
                      onRename={onRename}
                      onDelete={onDelete}
                      onCopyLink={onCopyLink}
                      onEditDescription={() => setIsDescriptionEditMode(true)}
                      onDuplicate={onDuplicate}
                      backgroundsColors={{
                        hover: SolutionColorVariables.sc2,
                        active: SolutionColorVariables.sc2,
                      }}
                    />
                  </DotsContainer>
                  <StyledHDivider marginR={12} />
                  <SwitcherAutomation
                    checked={candidate.isActiveStatus()}
                    onChange={(e) => {
                      toggleStatus(e, candidate.self);
                    }}
                  />
                </>
              )}
            </StyledHeaderTitleSection>
            {actions}
            <StyledHeaderSection>
              <Icons>
                <InfoIconButton
                  iconName="question-circle"
                  onClick={intercomOpenAutomationsArticle}
                />
                <CloseButton onClick={onClose} />
              </Icons>
            </StyledHeaderSection>
          </>
        )}
      </StyledModalHeader>
    );
  },
);
